"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgGridSolid(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M9.778 13c.672 0 1.222.55 1.222 1.222v8.556C11 23.45 10.45 24 9.778 24H1.222C.55 24 0 23.45 0 22.778v-8.556C0 13.55.55 13 1.222 13h8.556zm13 0c.672 0 1.222.55 1.222 1.222v8.556C24 23.45 23.45 24 22.778 24h-8.556C13.55 24 13 23.45 13 22.778v-8.556c0-.672.55-1.222 1.222-1.222h8.556zm0-13C23.45 0 24 .55 24 1.222v8.556C24 10.45 23.45 11 22.778 11h-8.556C13.55 11 13 10.45 13 9.778V1.222C13 .55 13.55 0 14.222 0h8.556zm-13-.002C10.45-.002 11 .548 11 1.22v8.556c0 .672-.55 1.222-1.222 1.222H1.222C.55 10.998 0 10.448 0 9.776V1.22C0 .548.55-.002 1.222-.002h8.556z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgGridSolid;
exports.default = _default;